const THEME_PREFIX = "md-theme-";
const DEFAULT_THEME = "dark";
const DEFAULT_THEME_COLOR = "lime500";
function getParent(property, component) {
  if (component) {
    const current = property === "mdTheme" ? component.mdTheme : component.mdThemeColor;
    const getParentTheme = parent => {
      if (parent) {
        const parentProperty = property === "mdTheme" ? parent.mdTheme : parent.mdThemeColor;
        if (parentProperty && parentProperty !== current) return parentProperty;else return getParentTheme(parent.$parent);
      }
      return property === "mdTheme" ? DEFAULT_THEME : DEFAULT_THEME_COLOR;
    };
    return getParentTheme(component.$parent);
  }
  return undefined;
}
var MdTheme = {
  props: {
    mdTheme: {
      type: String,
      default: ""
    },
    mdThemeColor: {
      type: String,
      default: ""
    }
  },
  computed: {
    $mdActiveTheme() {
      const theme = this.mdTheme || getParent("mdTheme", this);
      const color = this.mdThemeColor || getParent("mdThemeColor", this);
      return `${THEME_PREFIX}${theme}-${color}`;
    },
    $tmdActiveTheme() {
      const theme = this.mdTheme || getParent("mdTheme", this);
      const color = this.mdThemeColor || getParent("mdThemeColor", this);
      return `t${THEME_PREFIX}${theme} t${THEME_PREFIX}${theme}-${color}`;
    }
  }
};

export { MdTheme as default };
